/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiWorkshopId
 */
export interface ApiWorkshopId {
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshopId
     */
    workshopId: number;
}

export function ApiWorkshopIdFromJSON(json: any): ApiWorkshopId {
    return ApiWorkshopIdFromJSONTyped(json, false);
}

export function ApiWorkshopIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWorkshopId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workshopId': json['workshopId'],
    };
}

export function ApiWorkshopIdToJSON(value?: ApiWorkshopId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workshopId': value.workshopId,
    };
}

